

export enum ElementType {
  PRIMITIVE = 'PRIMITIVE',
  SHAPE = 'SHAPE',
  DOOR = 'DOOR',
  WINDOW = 'WINDOW',
  WALL = 'WALL',
  OPENING = 'OPENING',
  SLAB = 'SLAB',
  FLOOR = 'FLOOR',
  STAIR = 'STAIR',
  SPACECONTAINER = 'SPACECONTAINER',
  BOARD = 'BOARD',
  PAPER = 'PAPER',
  FIXTURE = 'FIXTURE',
  FURNITURE = 'FURNITURE',
  APPLIANCE = 'APPLIANCE',
  LANDSCAPE = 'LANDSCAPE',
  DATUM_LEVEL = 'DATUM_LEVEL',
  DATUM_GRID = 'DATUM_GRID',
  DATUM_REFERENCE_PLANE = 'DATUM_REFERENCE_PLANE',
  DATUM_PROJECT_ORIGIN = 'DATUM_PROJECT_ORIGIN',
  DATUM_SECTION_LINE = 'DATUM_SECTION_LINE',
  DATUM_ELEVATION_MARKER = 'DATUM_ELEVATION_MARKER',
}

export enum DoorType {
  GLASS = 'GLASS',
  WOOD = 'WOOD',
  DOUBLEDOOR = 'DOUBLEDOOR',
  SLIDING = 'SLIDING',
  FOLDING = 'FOLDING',
  DOUBLEACTION = 'DOUBLEACTION',
  OTHER = 'OTHER',
}

export enum WindowType {
  GLASS = 'GLASS',
  WOOD = 'WOOD',
  SLIDING = 'SLIDING',
  CASEMENT = 'CASEMENT',
  AWNING = 'AWNING',
  FIXED = 'FIXED',
  OTHER = 'OTHER',
}
